import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import styled from '@emotion/styled';

const LoadingContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  width: '100%',
  padding: '40px 0',
});

const LoadingState: React.FC = () => {
  return (
    <LoadingContainer>
      <CircularProgress
        size={48}
        sx={{ color: '#FF6A00', marginBottom: '20px' }}
      />
      <Typography variant="h6" sx={{ color: '#6F878F', marginBottom: '8px' }}>
        Loading Game Data
      </Typography>
      <Typography variant="body2" sx={{ color: '#6F878F' }}>
        Please wait while we fetch your game details...
      </Typography>
    </LoadingContainer>
  );
};

export default LoadingState;
